'use client';

import { PageAlbumFragment } from '@/@types/generated/sitecore';
import PartyHomeAlbum from '../PartyHomeAlbum';
import ImagePreview, { ImagePreviewGroup } from '../ImagePreview';

type Props = {
    content: PageAlbumFragment;
};

const PagePartyAlbumBlock = (props: Props) => {
    const { content } = props;
    const albumList = content.albumList;
    const imageList = albumList.map((img, index) => ({
        src: img.contentImage?.src,
        mediaType: img.mediaType?.value,
        videoSrc: img.videoSrc?.value,
        mediaCaption: img.mediaCaption?.value,
        id: index,
        videoOptions: {},
    }));
    return (
        <>
            {content.layoutBlock?.value === 'Slider' ? (
                <PartyHomeAlbum content={{ Item: { albumList: albumList } }} />
            ) : (
                <div className='xmd:columns-3 columns-1 gap-6'>
                    <ImagePreviewGroup
                        imageList={imageList}
                        canPreview
                        total={(imageList || []).length}
                    >
                        {albumList.map((item) => {
                            return (
                                <div className='pt-5' key={item.name}>
                                    <ImagePreview
                                        setting={{
                                            src: item.contentImage?.src,
                                            className: 'rounded-[5px]',
                                            rootClassName: 'w-full',
                                        }}
                                        mediaOption={{
                                            mediaType: item.mediaType?.value as
                                                | 'Video'
                                                | 'Photo'
                                                | undefined,
                                        }}
                                        canPreview
                                    />
                                </div>
                            );
                        })}
                    </ImagePreviewGroup>
                </div>
            )}
        </>
    );
};
export default PagePartyAlbumBlock;
